import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class RegisterService {

    token = '';
    email: String = '';
    fname: String = '';
    lname: String = '';
    password: String = '123456';
    username: String = '';
    from: String = '/';
    register_from = 0;

    access_token = null;
    provider = null;
    update = null;

    type = '';

    constructor() { }
}
